import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Combobox from '../../../atoms/Combobox';

function TimezoneController({ loading = false, timezone = null, disabled = false, onChange = () => {} }) {
  const timezoneDropDownList = useMemo(() => {
    return Intl.supportedValuesOf('timeZone').map((tz) => {
      return {
        id: tz,
        name: tz,
        selected: tz === timezone,
      };
    });
  }, [timezone]);

  function handleTimezoneChange(id, item) {
    onChange(id, item);
  }

  return (
    <Combobox
      loading={loading || !timezone}
      label="Timezone"
      items={timezoneDropDownList}
      disabled={disabled}
      onChange={(id, item) => handleTimezoneChange(id, item)}
      value={timezone}
    />
  );
}

TimezoneController.propTypes = {
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  timezone: PropTypes.string,
};

export default TimezoneController;
